import { jsx as _jsx } from "react/jsx-runtime";
import { AlignGroup } from 'react-d3-utils';
import { usePosition } from '../../hooks';
export function Group(props) {
    const { x: oldX, y: oldY, horizontalAlign = 'none', verticalAlign = 'none', style = {}, xAxis = 'x', yAxis = 'y', children, } = props;
    const { x, y } = usePosition({ x: oldX, y: oldY, xAxis, yAxis });
    return (_jsx(AlignGroup, { x: x, y: y, horizontalAlign: horizontalAlign, verticalAlign: verticalAlign, style: style, children: children }));
}
//# sourceMappingURL=Group.js.map